import React, { useState, useMemo, useEffect } from 'react';
import OutputObjects from '../OutputObject';
import { useSelector } from 'react-redux';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors';
import PaginationButtons from '@/components/PaginationButtons';

const SummarySection = ({ search, output, enablePagination }) => {
  const stepArguments = useSelector((state) => workflowScreenSelectors.activeWorkflowStep(state)?.arguments);
  const appSlug = useSelector((state) => workflowScreenSelectors.activeWorkflowStepApp(state)?.slug);

  const isIterate = appSlug === 'iterate';
  const activeIndex = stepArguments?.activeIndex;
  const dataKey = stepArguments?.dataKey;
  const dataKeyOutput = output?.data?.[0]?.[dataKey];
  const allOutputObjects = dataKey && dataKeyOutput && Array.isArray(dataKeyOutput) ? dataKeyOutput : output?.data;

  const [frontendPage, setFrontendPage] = useState(0);
  const frontendLimit = 20;

  useEffect(() => {
    if (enablePagination && Array.isArray(allOutputObjects)) {
      const totalPages = Math.ceil(allOutputObjects.length / frontendLimit);
      if (frontendPage >= totalPages && totalPages > 0) {
        setFrontendPage(totalPages - 1);
      }
    }
  }, [enablePagination, allOutputObjects, frontendPage, frontendLimit]);

  const { outputObjects, numberingStartIndex } = useMemo(() => {
    if (enablePagination && Array.isArray(allOutputObjects)) {
      const startIndex = frontendPage * frontendLimit;
      const endIndex = startIndex + frontendLimit;
      const paginatedOutput = allOutputObjects.slice(startIndex, endIndex);
      return { outputObjects: paginatedOutput, numberingStartIndex: startIndex };
    }

    const page = output?.meta?.output?.page || 0;
    const limit = dataKey && dataKeyOutput ? dataKeyOutput.length : output?.meta?.output?.limit || 20;
    const startIndex = allOutputObjects && Array.isArray(allOutputObjects) ? page * limit : 0;
    return { outputObjects: allOutputObjects, numberingStartIndex: startIndex };
  }, [enablePagination, allOutputObjects, frontendPage, dataKey, dataKeyOutput, output?.meta?.output?.page, output?.meta?.output?.limit]);

  const handlePageChange = (newPage) => {
    setFrontendPage(newPage);
  };

  return (
    <>
      <OutputObjects search={search} output={outputObjects} numberingStartIndex={numberingStartIndex} activeIterationIndex={activeIndex} selectableIndex={isIterate} />
      {enablePagination && Array.isArray(allOutputObjects) && allOutputObjects.length > 0 && <PaginationButtons total={allOutputObjects.length} limit={frontendLimit} initialPage={frontendPage} onPageChange={handlePageChange} />}
    </>
  );
};

export default SummarySection;
